import { useMemo } from "react";

import { useFetchFeatureConfig } from "../../hooks/useFetchFeatureConfig";

import { useFetchAllIntegrations } from "./useFetchAllIntegrations";

import type { FeaturesConfigType } from "../../constants/feature";

const isAppAllowed = (label: string, config: FeaturesConfigType): boolean => {
  switch (label) {
    case "teams":
      return config.apps_ms_teams;
    case "gmail":
      return config.apps_gmail;
    case "outlook":
      return config.apps_outlook;
    case "twitter":
      return config.apps_twitter;
    case "googledrive":
      return config.apps_google_drive;
    case "evernote":
      return config.apps_evernote;
    case "slack":
      return config.apps_slack;
    case "sharepoint":
      return config.apps_sharepoint;
    case "box":
      return config.apps_box;
    case "onedrive":
      return config.apps_onedrive;
    case "dropbox":
      return config.apps_dropbox;
    case "onenote":
      return config.apps_onenote;
    case "azure_storage":
      return config.apps_azure_blob;
    case "telegram":
      return config.apps_telegram;
    case "needldrive":
      return config.needldrive;
    case "india_regulatory_data":
      return config.capital_markets_indian;
    case "us_regulatory_data":
      return config.capital_markets_us;
    case "nz_regulatory_data":
      return config.capital_markets_nz;
    default:
      return true;
  }
};

export const useIntegrationSources = () => {
  const {
    data: config,
    isLoading: isConfigLoading,
    isError: isConfigError,
    error: configError,
  } = useFetchFeatureConfig();
  const {
    data: integrations,
    isLoading: isIntegrationsLoading,
    isError: isIntegrationsError,
    error: integrationsError,
  } = useFetchAllIntegrations();

  const allowedSources = useMemo(() => {
    if (!config || !integrations) return [];
    return integrations.filter((integration) =>
      isAppAllowed(integration.label, config),
    );
  }, [config, integrations]);

  return {
    data: allowedSources,
    isLoading: isConfigLoading || isIntegrationsLoading,
    isError: isConfigError || isIntegrationsError,
    error: configError || integrationsError,
  };
};
